import React from 'react'
import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import CaptionLanguageField from '../../../../../form-fields/super-cut/caption-language'

const CaptionLanguage = styled(CaptionLanguageField)`
    grid-column: span 1;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoCaptionLanguageField = ({ field }: Props) => {
    return (
        <CaptionLanguage
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoCaptionLanguageField
